import { render } from "./SkeletonRankingList.vue?vue&type=template&id=42cfe388"
import script from "./SkeletonRankingList.vue?vue&type=script&lang=js"
export * from "./SkeletonRankingList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__